const ROUTES = {
  mainPath: '/car',
  calculationPage: 'calculation',
  offerPage: 'offer',
  infoPage: 'info',
  summaryPage: 'summary',
  welcomeBack: 'welcome-back',
  welcome: 'welcome',
  moreInputsPage: 'more-inputs',
  paymentAppPath: 'apps/payment',
  carCalculationPath: 'privat/bilforsakring',
  motorcykelCalculationPath: 'privat/motorcykelforsakring',
  mopedCalculationPath: 'privat/mopedforsakring',
  homeCalculationPath: 'privat/hemforsakring',
  hgfHomeCalculationPath: 'partners/hyresgastforeningen/hgf-hemforsakring',
  rikshemHomeCalculationPath: 'partners/rikshem',
  villaCalculationPath: 'privat/villaforsakring',
  olicksfallCalculationPath: 'privat/olycksfallsforsakring',
  hgfPPICalculationPath: 'partners/hyresgastforeningen/bo-kvar-forsakring'
};

export default ROUTES;
